if (!window.__hadatProductCardAtcBound) {
  window.__hadatProductCardAtcBound = true;

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.product-card__add-to-cart');
    if (!btn) return;

    if (btn.disabled) return;

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.disabled = true;
    const label = btn.querySelector('span');
    const originalText = label ? label.textContent : '';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart_add_failed');
        return r.json();
      })
      .then(function () {
        if (label) label.textContent = btn.dataset.labelAdded || '';
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        const counter = document.querySelector('.header__cart-count');
        if (counter) {
          counter.textContent = cart.item_count;
          counter.style.display = cart.item_count > 0 ? '' : 'none';
        }
        document.dispatchEvent(new CustomEvent('cart:open'));
      })
      .catch(function () {})
      .finally(function () {
        setTimeout(function () {
          if (label) label.textContent = originalText;
          btn.disabled = false;
        }, 1500);
      });
  });
}
